<div class="bg-gray-50 min-h-screen flex items-center justify-center">
  <div class="bg-white w-3/4 md:w-1/3 rounded-xl md:py-7 p-5 md:px-10 flex flex-col items-center justify-center">
    <img src="assets/images/emblem.png" class="w-20" alt="">
    <span class="text-black text-xl font-bold mt-5 mb-2">{{ 'Set Your Password' | concat | translate }}</span>
    <p class="text-gray-dark text-center">{{ 'Please set a Password to gain access to the system' | concat | translate }}</p>
    <form (ngSubmit)="submitForm(form.value)" [formGroup]="form" class="w-full mt-3">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'New Password' | concat | translate }}</mat-label>
        <input [type]="showPassword ? 'password' : 'text'" matInput formControlName="password">
        <button type="button" mat-icon-button matSuffix (click)="showPassword = !showPassword"
                [attr.aria-label]="'Hide'"
                [attr.aria-pressed]="showPassword">
          <mat-icon class="material-icons-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>
        <mat-error>
          <span
            *ngIf="!form.get('password')?.valid && form.get('password')?.touched">
              {{ 'Field is required' | concat | translate }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'Confirm Password' | concat | translate }}</mat-label>
        <input [type]="showPassword2 ? 'password' : 'text'" matInput formControlName="confirmPassword">
        <button type="button" mat-icon-button matSuffix (click)="showPassword2 = !showPassword2"
                [attr.aria-label]="'Hide'"
                [attr.aria-pressed]="showPassword2">
          <mat-icon class="material-icons-outlined">{{ showPassword2 ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>
        <mat-error>
          <span
            *ngIf="!form.get('confirmPassword')?.valid && form.get('confirmPassword')?.value === form.get('password')?.value && form.get('confirmPassword')?.touched">
              {{ 'Field is required' | concat | translate }}
          </span>
        </mat-error>
      </mat-form-field>
      <div class="w-full mb-3">
        <button mat-raised-button color="primary" class="w-full" type="submit">{{ 'Set Password' | concat | translate }}</button>
      </div>
    </form>
  </div>
</div>
